<template>
<div>
  <div class="modal fade" ref="modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog vld-parent" role="document">
      <div class="modal-content">
        <div class="modal-header preorder-header" v-if="showPreorderWarning">
          <div>
            <h1 class="modal-title">Pre Order Only</h1>
            <div class="modal-header-body">Delivery is currently only available for Pre Orders</div>
            <button class="button button-primary" @click="openLearnMore">
              Learn More <i class="sk-icon-long-arrow-right-regular"></i>
            </button>
          </div>
          <button type="button" class="modal-close" data-dismiss="modal" aria-label="Close">
            <i class="sk-icon-times"></i>
          </button>
        </div>
        <div class="modal-header" v-else>
          <h1 class="modal-title">Delivery Time</h1>
          <button type="button" class="modal-close" data-dismiss="modal" aria-label="Close">
            <i class="sk-icon-times"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="delivery-options" v-if="asapAvailable">
            <div @click="setPreschedule(0)">
              <SkRadio :option="0" v-model="preschedule" /> 
              <span>ASAP</span>
            </div>
            <div @click="setPreschedule(1)">
              <SkRadio :option="1" v-model="preschedule" /> 
              <span>Pre Order</span>
            </div>
          </div>
          <div class="delivery-preschedule-details" v-if="preschedule">
            <h1 class="modal-title">Delivery Date</h1>
            <DeliveryDatePicker v-model="date" :schedule="businessSchedule"/>
            <h1 class="modal-title">Delivery Time</h1>
            <DeliveryTimePicker v-model="time" :schedule="businessSchedule" :currentDate="date"/>
            <button class="button button-primary" @click="setDeliveryTime">
              Start Preorder
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <PreorderLearnModal ref="learnMoreModal" />
</div>
</template>

<style scoped>
  .delivery-options {
    display: flex;
    width: 100%;
    justify-content: left;
    padding-bottom: 10px;
    padding-top: 10px;
  }

  .delivery-options > div {
    display: flex;
    align-items: center;
    flex: 1;
  }

  .modal-header {
    height: auto;
    min-height: 38px;
    align-items: center;
    justify-content: space-between;
  }

  .modal-header .button-primary {
    height: 25px;
    width: auto;
    padding: 0 20px;
    margin: 20px 0;
  }

  .modal-header .button-primary i {
    font-size: 10px;
    margin-left: 10px;
  }

  .modal-header-body {
    color: var(--sk-grey3);
    margin-top: 14px;
  }

  .modal-title,
  .modal-header-body,
  .modal-header .button-primary {
    margin-left: 20px;
  }

  .preorder-header {
    padding-top: 20px;
  }
  
  .modal-body {
    background: var(--sk-grey-bg);
  }

  .modal-close {
    position: absolute;
    top: 10px;
    right: 5px;
  }

  .delivery-preschedule-details {
    width: 100%;
  }

  .delivery-preschedule-details .modal-title {
    margin-left: 0;
    margin-bottom: 20px;
  }

  .delivery-preschedule-details .modal-title:not(:first-child) {
    margin-top: 46px;
  }

  .delivery-options + .delivery-preschedule-details .modal-title:first-child  {
    margin-top: 46px;
  }

  .modal-body .button.button-primary {
    margin-top: 39px;
  }

  * >>> .sk-radio input,
  * >>> .sk-radio {
    pointer-events: none;
  }
</style>

<script>
import moment from "moment"
import momentUtils from "@/moment-utils"
import SkRadio from  "@/components/common/SkRadio.vue"
import DeliveryDatePicker from "@/components/common/DeliveryDatePicker.vue"
import DeliveryTimePicker from "@/components/common/DeliveryTimePicker.vue"
import { MenuType } from "@reef-os/utils/enums/menuType"
import PreorderLearnModal from "@/components/modals/PreorderLearnModal.vue"

export default {
  name: "DeliveryTimeModal",
  components: {
    SkRadio,
    DeliveryDatePicker,
    DeliveryTimePicker,
    PreorderLearnModal
  },
  data: function() {
    return {
      preschedule: 0,
      date: null,
      time: null,
      businessSchedule: {},
      closed: null
    }
  },
  computed: {
    asapAvailable() {
      return this.$store.getters.asapAvailable
    },
    showPreorderWarning() {
      return !this.asapAvailable && !this.$store.state.deliveryDate
    }
  },
  methods: {
    open(options) {
      this.calculateBusinessSchedule()
      if (options && options.date) {
        this.preschedule = options.preschedule ? options.preschedule : 1
        this.date = options.date.date
        this.time = options.date.time
      } else {
        this.date = null
        this.time = null
        if (options && options.preschedule) {
          this.preschedule = options.preschedule
        } else {
          this.preschedule = this.asapAvailable ? 0 : 1
        }
      }
      this.$store.dispatch("sendMixpanelEvent", { msg:  "Delivery Time Modal Opened"})
      $(this.$refs.modal).modal("show")
      return new Promise(resolve =>  {
        this.closed = resolve
      })
    },
    close() {
      $(this.$refs.modal).modal("hide")
    },
    setPreschedule(preschedule) {
      if (this.$store.getters.itemsInCartCount > 0) {
        this.$emit("confirm", {
          confirmed: (hasConfirmed) => {
            if (hasConfirmed) {
              this.$store.dispatch("clearCart")
              this.preschedule = preschedule
            }
          }
        })
      } else {
        this.preschedule = preschedule
      }
    },
    setDeliveryTime() {
      if (this.$store.state.deliveryDate != null && this.$store.getters.itemsInCartCount > 0) {
        this.$emit("confirm", {
          confirmed: (hasConfirmed) => {
            if (hasConfirmed) {
              this.$store.dispatch("setDeliveryDate", {
                date: this.date,
                time: this.time
              })
            }
            this.close()
          }
        })
      } else {
        this.$store.dispatch("setDeliveryDate", {
          date: this.date,
          time: this.time
        })
        this.close()
      }
    },
    calculateBusinessSchedule() {
      let schedule = {
        0: [],
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: []
      }
      const schedules = this.$store.state.menuSchedules
      const menus = this.$store.getters.menusHash
      const todaysDow = momentUtils.todaysDow()
      const offset =
				this.$store.state.business &&
				this.$store.state.business.timezone_offset_adjusted
					? this.$store.state.business.timezone_offset_adjusted
					: 0
			const now = moment.utc().add(offset, "m")

      Object.keys(schedules)
        .filter(menuId => {
          let menu = menus && menus[menuId] && menus[menuId].menu ? menus[menuId].menu : null
          if (menu) {
            const isPopupMenu = menu.type == MenuType.POPUP
            const isPrepackaged = menu.type == MenuType.PRE_PACKAGED
            return !isPopupMenu && !isPrepackaged
          }
          return false
        })
        .forEach(menuId => {
          const menuSchedule = schedules[menuId]
          let menu = menus && menus[menuId] && menus[menuId].menu ? menus[menuId].menu : null
          let inStock = menu.stock_status == 1
          let todaysSchedule = Object.values(menuSchedule).flat().filter(schedule => schedule.rangesFrom == todaysDow)
          let shouldBeInStock = todaysSchedule.some(todaySchedule => {
            return momentUtils.isBetweenTimes(now, todaySchedule.openTime, todaySchedule.closeTime)
          })

          Object.keys(menuSchedule).forEach(dow => {
            let dowSchedules = menuSchedule[dow]
            if (shouldBeInStock && !inStock) {
              dowSchedules = dowSchedules.filter(schedule => {
                return todaysDow != schedule.rangesFrom
              })
            }
            schedule[dow] = schedule[dow].concat(dowSchedules)
          })
        })
      this.businessSchedule = schedule
    },
    openLearnMore() {
      this.$refs.learnMoreModal.open()
    }
  },
  mounted: function() {
    $(this.$refs.modal).on("hidden.bs.modal", () => {
      if (this.closed) {
        this.closed()
        this.closed = null
      }
    })
  },
  watch: {
    preschedule(newVal) {
      if (!newVal) {
        this.$store.dispatch("setDeliveryDate", {
          date: null,
          time: null
        })
      }
    }
  }
}
</script>
